import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@environment';
import { ImageService } from '@wizbii/angular-utilities';
import { WizFile } from '@wizbii/models';

@Component({
  selector: 'app-wiz-file',
  templateUrl: './wiz-file.component.html',
  styleUrls: ['./wiz-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizFileComponent implements OnChanges {
  @Input() model: WizFile;
  @Input() uploadPercentage: number;
  @Input() editable = true;

  set modelName(modelName: string) {
    if (!this.model.name) {
      return;
    }
    const ext = this.model.name.split('.')[1];
    this.model.name = ext ? `${modelName}.${ext}` : modelName;
  }
  get modelName(): string {
    return this.model.name ? this.model.name.split('.')[0] : '';
  }

  src: string;
  loaded = false;
  uploadCompleted = false;

  constructor(private readonly cdr: ChangeDetectorRef, private readonly imageService: ImageService) {}

  ngOnChanges({ model }: SimpleChanges): void {
    if (
      model &&
      !model.isFirstChange() &&
      model.previousValue.name &&
      !model.previousValue.id &&
      model.currentValue.id
    ) {
      // the file receive its id only after it has been uploaded successfully
      this.uploadCompleted = true;
    }
    if (this.model) {
      const initialUrl = `${environment.api.googleStorage}/${environment.wizbiiFiles}/${this.model.id}`;
      this.src = this.imageService.resize(initialUrl, { width: 176, height: 251 });
    }
  }

  handleLoad(): void {
    this.loaded = true;
    this.cdr.markForCheck();
  }

  handleError(): void {
    this.src = null;
    this.cdr.markForCheck();
  }
}
